import FormPhoneAndOTP from "@components/inputs/FormPhoneAndOTP";
import FormUsernamePassword from "@components/inputs/FormUsernamePassword";
import { usePostLoginCheck } from "@components/utils/Auth/hooks";
import { LoginCallbackProps } from "@components/utils/Auth/types";

interface LoginUPProps extends LoginCallbackProps {
  defaultMethod: "phone" | "username";
  onAccountLocked?: (isLocked: boolean) => void;
  isAccountLocked?: boolean;
}

const LoginUP = ({ defaultMethod, onAccountLocked, isAccountLocked, onLoginSuccess, onForgotSecret }: LoginUPProps) => {
  const postLoginCheck = usePostLoginCheck({
    onLoginSuccess,
  });

  return (
    <>
      {defaultMethod === "phone" && (
        <div className="w-full animate-fade-in">
          <FormPhoneAndOTP
            onLoginSuccess={postLoginCheck}
            onForgotSecret={onForgotSecret}
            onAccountLocked={onAccountLocked}
            isAccountLocked={isAccountLocked}
          />
        </div>
      )}

      {defaultMethod === "username" && (
        <div className="w-full animate-fade-in">
          <FormUsernamePassword
            onLoginSuccess={postLoginCheck}
            onForgotSecret={onForgotSecret}
            onAccountLocked={onAccountLocked}
            isAccountLocked={isAccountLocked}
          />
        </div>
      )}
    </>
  );
};

export default LoginUP;
